import { render, staticRenderFns } from "./Barang.vue?vue&type=template&id=55e15b42"
import script from "./Barang.vue?vue&type=script&lang=js"
export * from "./Barang.vue?vue&type=script&lang=js"
import style0 from "./Barang.vue?vue&type=style&index=0&id=55e15b42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports